/* THE ROYAL STRAPS — THEME JS */

document.addEventListener('DOMContentLoaded', function () {

  const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;

  /* ================================================================
     DESKTOP: Floating bubble cursor + trailing ring
  ================================================================ */
  if (!isTouchDevice) {
    const cursor = document.getElementById('cursor');
    const ring   = document.getElementById('cursorRing');
    if (cursor && ring) {
      let mx = 0, my = 0, rx = 0, ry = 0;
      document.addEventListener('mousemove', e => {
        mx = e.clientX; my = e.clientY;
        cursor.style.left = mx + 'px';
        cursor.style.top  = my + 'px';
      });
      (function animateRing() {
        rx += (mx - rx) * 0.12;
        ry += (my - ry) * 0.12;
        ring.style.left = rx + 'px';
        ring.style.top  = ry + 'px';
        requestAnimationFrame(animateRing);
      })();
    }
  }

  /* ================================================================
     MOBILE: Finger-locked bubble + lagging ring
     - Bubble uses transform (GPU) and snaps 1:1 to finger — zero lag
     - Ring interpolates behind it in rAF for the smooth trail feel
     - On lift: both drift to nearest corner via CSS transition then fade
  ================================================================ */
  if (isTouchDevice) {

    const desktopCursor = document.getElementById('cursor');
    const desktopRing   = document.getElementById('cursorRing');
    if (desktopCursor) desktopCursor.style.display = 'none';
    if (desktopRing)   desktopRing.style.display   = 'none';

    const style = document.createElement('style');
    style.textContent = `
      #m-bubble, #m-ring {
        position: fixed;
        top: 0;
        left: 0;
        border-radius: 50%;
        pointer-events: none;
        z-index: 9999;
        will-change: transform, opacity;
        opacity: 0;
      }
      #m-bubble {
        width: 12px;
        height: 12px;
        background: #0047FF;
        z-index: 10000;
        margin-top: -6px;
        margin-left: -6px;
      }
      #m-ring {
        width: 38px;
        height: 38px;
        border: 1.5px solid #0047FF;
        z-index: 9999;
        margin-top: -19px;
        margin-left: -19px;
      }
      #m-bubble.visible { opacity: 1; }
      #m-ring.visible   { opacity: 1; }
      #m-bubble.returning {
        transition: transform 0.65s cubic-bezier(0.25,0.46,0.45,0.94),
                    opacity   0.4s  ease 0.35s;
        opacity: 0 !important;
      }
      #m-ring.returning {
        transition: transform 0.75s cubic-bezier(0.25,0.46,0.45,0.94),
                    opacity   0.3s  ease 0.2s;
        opacity: 0 !important;
      }
    `;
    document.head.appendChild(style);

    const bubble = document.createElement('div');
    bubble.id = 'm-bubble';
    document.body.appendChild(bubble);

    const mring = document.createElement('div');
    mring.id = 'm-ring';
    document.body.appendChild(mring);

    // Current finger position (viewport coords)
    let fx = 0, fy = 0;
    // Ring interpolation position
    let rx = 0, ry = 0;
    let isDown = false;
    let returnTimer = null;
    let rafId = null;

    function setTransform(el, x, y) {
      el.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
    }

    function loop() {
      // Ring chases finger with smooth interpolation
      rx += (fx - rx) * 0.18;
      ry += (fy - ry) * 0.18;
      setTransform(mring, rx, ry);
      rafId = requestAnimationFrame(loop);
    }

    function startLoop() {
      if (!rafId) rafId = requestAnimationFrame(loop);
    }

    function onTouchStart(e) {
      clearTimeout(returnTimer);

      // Strip returning class without transition
      bubble.style.transition = 'none';
      mring.style.transition  = 'none';
      bubble.classList.remove('returning');
      mring.classList.remove('returning');

      const t = e.touches[0];
      fx = t.clientX;
      fy = t.clientY;
      rx = fx; ry = fy; // snap ring too on first touch

      // Move bubble instantly — no interpolation, pure GPU
      setTransform(bubble, fx, fy);
      setTransform(mring,  rx, ry);

      bubble.classList.add('visible');
      mring.classList.add('visible');
      isDown = true;
      startLoop();
    }

    function onTouchMove(e) {
      // Use the raw touch — no throttle, no lag
      const t = e.touches[0];
      fx = t.clientX;
      fy = t.clientY;
      // Bubble snaps directly — GPU composited, always 60/120fps
      setTransform(bubble, fx, fy);
    }

    function onTouchEnd() {
      isDown = false;

      // Nearest corner in viewport
      const W  = window.innerWidth;
      const H  = window.innerHeight;
      const cx = fx < W / 2 ? 20 : W - 20;
      const cy = fy < H / 2 ? 20 : H - 20;

      // Apply CSS transitions for the drift
      bubble.classList.add('returning');
      mring.classList.add('returning');
      setTransform(bubble, cx, cy);
      setTransform(mring,  cx, cy);

      // Stop rAF after animation settles, then hide
      returnTimer = setTimeout(() => {
        cancelAnimationFrame(rafId);
        rafId = null;
        bubble.classList.remove('visible', 'returning');
        mring.classList.remove('visible', 'returning');
        // Reset to corner so next touch starts cleanly
        fx = cx; fy = cy;
        rx = cx; ry = cy;
      }, 1100);
    }

    document.addEventListener('touchstart',  onTouchStart,  { passive: true });
    document.addEventListener('touchmove',   onTouchMove,   { passive: true });
    document.addEventListener('touchend',    onTouchEnd,    { passive: true });
    document.addEventListener('touchcancel', onTouchEnd,    { passive: true });
  }

  /* ================================================================
     MOBILE NAV
  ================================================================ */
  const toggle    = document.getElementById('mobileToggle');
  const mobileNav = document.getElementById('mobileNav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => mobileNav.classList.toggle('open'));
  }

  /* ================================================================
     SCROLL REVEAL
  ================================================================ */
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.08 });
    reveals.forEach(el => obs.observe(el));
  }

  /* ================================================================
     PRODUCT GALLERY + VARIANT-LINKED IMAGES
     Each thumb has data-variant-ids="123,456" (set from Shopify's
     image.variant_ids in product.liquid). Selecting a variant filters
     the strip to only that variant's images and swaps the main photo.
  ================================================================ */
  const productThumbs   = document.querySelectorAll('.product-thumb');
  const productMainImg  = document.querySelector('.product-main-img img');
  const mainImgCaption  = document.getElementById('mainImgCaptionValue');

  // Variant → image map (rendered by main-product.liquid). Lets a variant
  // click swap the main photo even when Shopify has no per-variant image set.
  let variantImageMap = {};
  const variantImageData = document.getElementById('variantImageMap');
  if (variantImageData) {
    try {
      JSON.parse(variantImageData.textContent).forEach(function (v) {
        if (v && v.id != null && v.src) variantImageMap[String(v.id)] = v.src;
      });
    } catch (e) {}
  }

  // The main <img> is rendered with a srcset (responsive sizes). Browsers pick
  // the image from srcset in preference to src, so updating src alone never
  // visibly changes the photo — that is what made the image look "static".
  // Clearing srcset/sizes forces the new src to actually display.
  function setMainImageSrc(src) {
    if (!src || !productMainImg) return;
    productMainImg.removeAttribute('srcset');
    productMainImg.removeAttribute('sizes');
    productMainImg.src = src;
  }

  // Update the colour name shown under the big image.
  function setCaption(name) {
    if (mainImgCaption && name) mainImgCaption.textContent = name;
  }

  function swapMainImage(src) {
    if (!src || !productMainImg) return;
    setMainImageSrc(src);
    productThumbs.forEach(function (t) {
      t.classList.toggle('active', (t.dataset.fullSrc || '') === src);
    });
  }

  function setActiveThumb(thumb) {
    if (!thumb) return;
    productThumbs.forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    if (productMainImg) {
      const fullSrc = thumb.dataset.fullSrc || thumb.querySelector('img').src;
      setMainImageSrc(fullSrc);
    }
  }

  // When a thumbnail is clicked, mirror that choice onto the matching colour
  // swatch + caption so the big photo and the selected colour never disagree.
  function syncSwatchToThumb(thumb) {
    const ids = (thumb.dataset.variantIds || '').split(',').filter(Boolean);
    if (!ids.length) return;
    const btns = document.querySelectorAll('.variant-btn');
    let match = null;
    btns.forEach(function (b) {
      if (!match && ids.indexOf(String(b.dataset.variantId)) !== -1) match = b;
    });
    if (!match) return;
    btns.forEach(b => b.classList.remove('active'));
    match.classList.add('active');
    const name = (match.dataset.variantName || '').trim();
    setCaption(name);
    const sel = document.querySelector('.variant-selected');
    if (sel && name) sel.textContent = name;
    const variantInput = document.getElementById('variant-id');
    if (variantInput && match.dataset.variantId) variantInput.value = match.dataset.variantId;
  }

  productThumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      setActiveThumb(thumb);
      syncSwatchToThumb(thumb);
    });
  });

  function filterThumbsByVariant(variantId) {
    if (!productThumbs.length) return;

    // If no thumbs are explicitly linked to variants, leave them all visible
    const hasLinkage = Array.from(productThumbs).some(t =>
      (t.dataset.variantIds || '').split(',').filter(Boolean).length > 0
    );

    if (!hasLinkage || !variantId) {
      productThumbs.forEach(t => { t.style.display = ''; });
      return;
    }

    const anyMatch = Array.from(productThumbs).some(t =>
      (t.dataset.variantIds || '').split(',').filter(Boolean).includes(String(variantId))
    );
    if (!anyMatch) { productThumbs.forEach(t => { t.style.display = ''; }); return; }

    let firstVisible = null;
    productThumbs.forEach(t => {
      const ids = (t.dataset.variantIds || '').split(',').filter(Boolean);
      const show = ids.includes(String(variantId));
      t.style.display = show ? '' : 'none';
      if (show && !firstVisible) firstVisible = t;
    });

    if (firstVisible) setActiveThumb(firstVisible);
  }

  /* ================================================================
     QTY SELECTOR
  ================================================================ */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;
    e.preventDefault();
    const input = btn.closest('.qty-selector').querySelector('.qty-input');
    if (!input) return;
    let val = parseInt(input.value) || 1;
    if (btn.dataset.action === 'minus') val = Math.max(1, val - 1);
    if (btn.dataset.action === 'plus')  val = Math.min(99, val + 1);
    input.value = val;
    const formQty = document.getElementById('form-qty');
    if (formQty) formQty.value = val;
  });

  document.addEventListener('focusin', function (e) {
    if (!e.target.classList.contains('qty-input')) return;
    e.target.select();
  });

  document.addEventListener('input', function (e) {
    if (!e.target.classList.contains('qty-input')) return;
    const formQty = document.getElementById('form-qty');
    if (formQty) formQty.value = e.target.value;
  });

  document.addEventListener('focusout', function (e) {
    if (!e.target.classList.contains('qty-input')) return;
    let val = parseInt(e.target.value);
    if (isNaN(val) || val < 1) val = 1;
    if (val > 99) val = 99;
    e.target.value = val;
    const formQty = document.getElementById('form-qty');
    if (formQty) formQty.value = val;
  });

  /* ================================================================
     CART QTY
  ================================================================ */
  document.querySelectorAll('[data-cart-qty]').forEach(btn => {
    btn.addEventListener('click', () => {
      const key    = btn.dataset.key;
      const action = btn.dataset.action;
      const input  = document.querySelector(`input[data-line-key="${key}"]`);
      if (!input) return;
      let val = parseInt(input.value) || 1;
      if (action === 'minus') val = Math.max(0, val - 1);
      if (action === 'plus')  val = val + 1;
      input.value = val;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: val })
      }).then(() => location.reload());
    });
  });

  /* ================================================================
     COLLECTION FILTERS
  ================================================================ */
  const filterBtns = document.querySelectorAll('.filter-btn');
  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      filterBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  /* ================================================================
     VARIANT SELECTOR
  ================================================================ */
  const variantBtns     = document.querySelectorAll('.variant-btn');
  const selectedDisplay = document.querySelector('.variant-selected');
  variantBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('sold-out')) return;
      variantBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      // Prefer the explicit variant name (set on swatches) over the button's
      // text so the "selected" label stays clean even with thumbnail markup.
      var pickedName = (btn.dataset.variantName || btn.textContent).trim();
      if (selectedDisplay) selectedDisplay.textContent = pickedName;
      setCaption(pickedName);
      const variantInput = document.getElementById('variant-id');
      if (variantInput && btn.dataset.variantId) {
        variantInput.value = btn.dataset.variantId;
      }

      // Swap the main photo to this variant's image. Prefer an image assigned
      // to the variant in Shopify, then the variant→image map (position fallback).
      var newSrc = btn.dataset.variantImage || variantImageMap[String(btn.dataset.variantId)];
      if (newSrc) swapMainImage(newSrc);

      // If multiple images are explicitly linked to this variant, filter the
      // thumbnail strip to them (safely leaves the strip alone if none match).
      if (btn.dataset.variantId) filterThumbsByVariant(btn.dataset.variantId);
    });
  });

  // Filter the gallery to the initially selected variant on page load
  const initialActiveVariant = document.querySelector('.variant-btn.active');
  if (initialActiveVariant && initialActiveVariant.dataset.variantId) {
    filterThumbsByVariant(initialActiveVariant.dataset.variantId);
  }

});
